import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, MessageCircle, Facebook, Instagram } from 'lucide-react';
import { mockData } from '../mock/data';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-logo">
            <span className="logo-text">NeoNkawa</span>
            <span className="tagline">propre et sécurisé</span>
          </div>
          <p className="footer-description">
            Service professionnel de nettoyage Airbnb à Meknès.
            Garantissez votre note 4.9★ avec notre équipe experte.
          </p>
        </div>

        <div className="footer-section">
          <h4>Navigation</h4>
          <ul className="footer-links">
            <li><Link to="/">Accueil</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/tarifs">Tarifs</Link></li>
            <li><Link to="/temoignages">Témoignages</Link></li>
            <li><Link to="/a-propos">À Propos</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Services</h4>
          <ul className="footer-links">
            <li><a href="#services">Nettoyage Express</a></li>
            <li><a href="#services">Abonnements</a></li>
            <li><a href="#services">Service Urgence</a></li>
            <li><a href="#services">Nettoyage Profond</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <ul className="footer-contact">
            <li>
              <Phone size={16} />
              <span>{mockData.contact.phone}</span>
            </li>
            <li>
              <MapPin size={16} />
              <span>{mockData.contact.location}</span>
            </li>
            <li>
              <Mail size={16} />
              <span>contact@neonkawa.ma</span>
            </li>
          </ul>
          <div className="footer-social">
            <a href="#" aria-label="WhatsApp" className="social-link">
              <MessageCircle size={20} />
            </a>
            <a href="#" aria-label="Facebook" className="social-link">
              <Facebook size={20} />
            </a>
            <a href="#" aria-label="Instagram" className="social-link">
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 NeoNkawa. Tous droits réservés.</p>
        <div className="footer-legal">
          <a href="#">Politique de confidentialité</a>
          <span>•</span>
          <a href="#">Conditions d'utilisation</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;